// list-menu.component.ts
import { Component, Input } from '@angular/core';
import { ArticoloFull } from 'src/app/shared/interfaces/custom/articolo';
import { Link } from 'src/app/shared/interfaces/link';

@Component({
  selector: 'app-list-menu',
  templateUrl: './list-menu.component.html',
  styleUrls: ['./list-menu.component.scss'],
})
export class ListMenuComponent {
  @Input() items: ArticoloFull[] = [];
  @Input() breadcrumbs: Link[] = [];
}
